(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-grid"] && !Shopify.designMode) return;
  try {
    
  // A–Z-Filter: Progressive Enhancement — Leiste erscheint nur mit JS,
  // ohne JS bleibt das Raster ungefiltert voll sichtbar.
  (function () {
    function init(root) {
      var bar = root.querySelector('[data-alpha]');
      var grid = root.querySelector('[data-alpha-grid]');
      if (!bar || !grid || bar.dataset.alphaInit) return;
      bar.dataset.alphaInit = '1';
      bar.hidden = false;
      var btns = bar.querySelectorAll('.brand-reg__alpha-btn');
      btns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.classList.contains('is-active') ? 'true' : 'false');
        btn.addEventListener('click', function () {
          var letter = btn.dataset.letter;
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          grid.querySelectorAll('.brand-reg__item').forEach(function (li) {
            li.hidden = letter !== '*' && li.dataset.letter !== letter;
          });
        });
      });
    }
    function all() {
      document.querySelectorAll('.brand-reg').forEach(init);
    }
    if (document.readyState !== 'loading') all();
    else document.addEventListener('DOMContentLoaded', all);
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cinematic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.hcineInit) return;
      root.dataset.hcineInit = '1';

      var mm = window.matchMedia;
      var reduce = mm && mm('(prefers-reduced-motion: reduce)').matches;
      var scenes = Array.prototype.slice.call(root.querySelectorAll('.hcine__scene'));
      var dotsWrap = root.querySelector('.hcine__dots');
      var interval = (parseFloat(root.dataset.interval) || 8) * 1000;

      var dots = [];
      if (dotsWrap && scenes.length > 1) {
        scenes.forEach(function (_, i) {
          var d = document.createElement('span');
          d.className = 'hcine__dot' + (i === 0 ? ' is-active' : '');
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      // Sanfter Dissolve zwischen den Bildern (kein Zoom) — offscreen pausierbar
      var idx = 0;
      function startFade() {
        if (root._hcineIv || reduce || scenes.length < 2) return;
        root._hcineIv = setInterval(function () {
          var next = (idx + 1) % scenes.length;
          scenes[idx].style.opacity = '0';
          scenes[next].style.opacity = '1';
          if (dots.length) {
            dots[idx].classList.remove('is-active');
            dots[next].classList.add('is-active');
          }
          idx = next;
        }, interval);
      }
      function stopFade() { if (root._hcineIv) { clearInterval(root._hcineIv); root._hcineIv = null; } }
      startFade();

      if ('IntersectionObserver' in window) {
        root._hcineIO = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) startFade(); else stopFade();
          }
        }, { threshold: 0.01 });
        root._hcineIO.observe(root);
      }
    }

    function initAll() {
      var nodes = document.querySelectorAll('.hcine');
      for (var i = 0; i < nodes.length; i++) initHero(nodes[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector ? e.target.querySelector('.hcine') : null;
      if (r) initHero(r);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var r = e.target.querySelector ? e.target.querySelector('.hcine') : null;
      if (r) {
        if (r._hcineIv) clearInterval(r._hcineIv);
        if (r._hcineIO) r._hcineIO.disconnect();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
